
import { Vue, Component } from "vue-property-decorator";
import CapacityPending from "./pending/index.vue";
import CapacitySubmitted from "./submitted/index.vue";
@Component({
  components: {
    CapacityPending,
    CapacitySubmitted,
  },
})
export default class CapacityManage extends Vue {
  activeTab = "pending";
  pendingCount = 0;
  handlePendingCountChange(val: number) {
    this.pendingCount = val;
  }
}
